import { Box, Typography } from '@mui/material';
import { RepurchaseCoupon } from '@/data/Content/RepurchaseCoupon';
import { getCouponValidityHint } from '@/components/blocks/DpRepurchaseCoupon/formatCouponDate';
import {
	CouponCheckIcon,
	CouponTicketIcon,
} from '@/components/blocks/DpRepurchaseCoupon/parts/CouponIcons';
import { RepurchaseActivateCheck } from '@/components/blocks/DpRepurchaseCoupon/parts/RepurchaseActivateCheck';
import {
	repurchaseCouponAppliedHeadSX,
	repurchaseCouponAppliedSX,
	repurchaseCouponAvailableSX,
} from '@/components/blocks/DpRepurchaseCoupon/styles/container';
import {
	repurchaseCouponHintSX,
	repurchaseCouponTextSX,
	repurchaseStrongSX,
} from '@/components/blocks/DpRepurchaseCoupon/styles/typography';

type Props = {
	coupon: RepurchaseCoupon;
	onApply: () => void;
};

const AppliedCard = ({ percentage, hint }: { percentage: number; hint: string }) => (
	<Box role="status" sx={repurchaseCouponAppliedSX}>
		<Box component="span" sx={repurchaseCouponAppliedHeadSX}>
			<CouponCheckIcon />
			<CouponTicketIcon width={24} height={22} />
			<Typography component="span" sx={repurchaseCouponTextSX}>
				<Typography component="strong" sx={repurchaseStrongSX}>
					{`${percentage}% OFF`}
				</Typography>
				{' aplicado.'}
			</Typography>
		</Box>
		{hint ? (
			<Typography component="span" sx={repurchaseCouponHintSX}>
				{hint}
			</Typography>
		) : null}
	</Box>
);

export const RepurchaseCouponCard = ({ coupon, onApply }: Props) => {
	const hint = getCouponValidityHint(coupon.expirationDateTime);

	if (coupon.status === 'APPLIED') {
		return <AppliedCard percentage={coupon.percentage} hint={hint} />;
	}

	return (
		<RepurchaseActivateCheck
			percentage={coupon.percentage}
			expirationDateTime={coupon.expirationDateTime}
			onApply={onApply}
			source="landing"
			sx={repurchaseCouponAvailableSX}
			urgencyBelow
		>
			<Typography component="span" sx={repurchaseCouponHintSX}>
				{hint}
			</Typography>
		</RepurchaseActivateCheck>
	);
};
